class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);

/* Splity navigation veil — premium transition for internal Splity navigation. */
(() => {
  if (window.__splityNavigationVeilV2) return;
  window.__splityNavigationVeilV2 = true;

  const root = document.documentElement;
  const CLASS_NAME = 'splity-page-leaving';
  const DARK_LOGO = 'https://cdn.shopify.com/s/files/1/0813/8925/6927/files/splity-logo-dark-4k.png?v=1786655848';
  const LIGHT_LOGO = 'https://cdn.shopify.com/s/files/1/0813/8925/6927/files/splity-logo-light-4k.png?v=1786655842';

  const PAGE_NAMES = {
    '/': 'Inicio',
    '/pages/inicio': 'Inicio',
    '/pages/explorar-servicios': 'Explorar servicios',
    '/pages/mis-grupos': 'Mis grupos',
    '/pages/mis-suscripciones': 'Mis suscripciones',
    '/pages/billetera': 'Billetera',
    '/pages/mi-perfil': 'Mi perfil',
    '/pages/perfil': 'Perfil',
    '/pages/mensajes': 'Mensajes',
    '/pages/referidos': 'Referidos',
    '/pages/contacto': 'Contacto',
    '/pages/terminos-y-condiciones': 'Términos y condiciones',
    '/pages/politica-de-privacidad': 'Política de privacidad'
  };

  const cleanLabel = (value) => String(value || '')
    .replace(/\s+/g, ' ')
    .replace(/^[←→›»]+\s*/, '')
    .trim()
    .slice(0, 52);

  const getDestinationLabel = (link, url) => {
    const explicit = cleanLabel(link?.dataset?.loadingLabel || link?.getAttribute?.('aria-label'));
    if (explicit) return explicit;

    const mapped = PAGE_NAMES[url.pathname];
    if (mapped) return mapped;

    const text = cleanLabel(link?.textContent);
    if (text && text.length <= 40) return text;

    const slug = decodeURIComponent(url.pathname.split('/').filter(Boolean).pop() || 'Splity')
      .replace(/[-_]+/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
    return cleanLabel(slug) || 'Splity';
  };

  const ensureVeil = () => {
    if (!document.head || !document.body || document.getElementById('splity-navigation-veil')) return;

    if (!document.getElementById('splity-navigation-veil-style')) {
      const style = document.createElement('style');
      style.id = 'splity-navigation-veil-style';
      style.textContent = `
        #splity-navigation-veil{position:fixed;inset:0;z-index:2147483640;display:grid;place-items:center;background:#08080c;opacity:0;visibility:hidden;pointer-events:none;transition:opacity .14s ease,visibility 0s linear .14s;contain:layout paint style}
        #splity-navigation-veil .splity-navigation-veil__content{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:18px;padding:28px;text-align:center;transform:translateY(5px);opacity:.96}
        #splity-navigation-veil img{display:block;width:min(300px,66vw);height:auto;max-height:138px;object-fit:contain;will-change:transform,filter;filter:drop-shadow(0 10px 30px rgba(112,67,255,.22));animation:splityLogoLoading .8s cubic-bezier(.4,0,.2,1) infinite alternate}
        #splity-navigation-veil .splity-navigation-veil__label{max-width:min(520px,86vw);font:600 clamp(14px,2.7vw,18px)/1.35 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;letter-spacing:.01em;color:rgba(255,255,255,.88)}
        #splity-navigation-veil .splity-navigation-veil__label::after{content:'…';display:inline-block;width:1em;text-align:left;animation:splityDots .8s steps(4,end) infinite}
        html[data-splity-theme="light"] #splity-navigation-veil{background:#fff}
        html[data-splity-theme="light"] #splity-navigation-veil .splity-navigation-veil__label{color:rgba(17,17,17,.78)}
        html.splity-page-leaving #splity-navigation-veil{opacity:1;visibility:visible;pointer-events:auto;transition:opacity .1s ease}
        @keyframes splityLogoLoading{0%{transform:translate3d(0,0,0) scale(.97);filter:drop-shadow(0 8px 24px rgba(112,67,255,.16))}100%{transform:translate3d(0,-8px,0) scale(1.035);filter:drop-shadow(0 16px 38px rgba(112,67,255,.34))}}
        @keyframes splityDots{0%{clip-path:inset(0 100% 0 0)}100%{clip-path:inset(0 0 0 0)}}
        @media(max-width:560px){#splity-navigation-veil img{width:min(235px,68vw);max-height:112px}#splity-navigation-veil .splity-navigation-veil__content{gap:14px}}
        @media(prefers-reduced-motion:reduce){#splity-navigation-veil,#splity-navigation-veil img,#splity-navigation-veil .splity-navigation-veil__label::after{transition:none!important;animation:none!important}}
      `;
      document.head.appendChild(style);
    }

    const veil = document.createElement('div');
    veil.id = 'splity-navigation-veil';
    veil.setAttribute('role', 'status');
    veil.setAttribute('aria-live', 'polite');
    veil.setAttribute('aria-atomic', 'true');

    const content = document.createElement('div');
    content.className = 'splity-navigation-veil__content';

    const logo = document.createElement('img');
    logo.alt = 'Splity';
    logo.decoding = 'async';
    logo.fetchPriority = 'low';
    logo.src = root.dataset.splityTheme === 'light' ? LIGHT_LOGO : DARK_LOGO;

    const label = document.createElement('div');
    label.className = 'splity-navigation-veil__label';
    label.textContent = 'Cargando Splity';

    content.append(logo, label);
    veil.appendChild(content);
    document.body.appendChild(veil);
  };

  const show = (labelText = 'Splity') => {
    ensureVeil();
    const logo = document.querySelector('#splity-navigation-veil img');
    const label = document.querySelector('#splity-navigation-veil .splity-navigation-veil__label');
    if (logo) logo.src = root.dataset.splityTheme === 'light' ? LIGHT_LOGO : DARK_LOGO;
    if (label) label.textContent = `Cargando ${cleanLabel(labelText) || 'Splity'}`;
    root.classList.add(CLASS_NAME);
  };

  const hide = () => root.classList.remove(CLASS_NAME);

  const getNavigation = (event, link) => {
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return null;
    if (link.hasAttribute('download') || link.target === '_blank' || link.hasAttribute('data-no-page-transition')) return null;
    const raw = String(link.getAttribute('href') || '').trim();
    if (!raw || raw === '#' || /^(mailto:|tel:|sms:|javascript:)/i.test(raw)) return null;

    let url;
    try { url = new URL(link.href, window.location.href); } catch (_) { return null; }
    if (url.origin !== window.location.origin) return null;
    if (url.pathname === location.pathname && url.search === location.search && url.hash) return null;
    return { url, label: getDestinationLabel(link, url) };
  };

  const start = () => {
    ensureVeil();
    window.addEventListener('pageshow', hide);
    window.addEventListener('pagehide', () => root.classList.add(CLASS_NAME));

    document.addEventListener('click', (event) => {
      const link = event.target.closest?.('a[href]');
      const navigation = getNavigation(event, link);
      if (!navigation) return;

      window.setTimeout(() => {
        const sharedMenuRedirect = link.matches?.('.splity-shared-menu a[href]');
        if (!event.defaultPrevented || sharedMenuRedirect) show(navigation.label);
      }, 0);
    });
  };

  window.SplityPageTransition = {
    show,
    hide,
    duration: 800
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
